// WizardStep1.js
import React, { useEffect } from 'react';
import PracticeLocationSelector from '../../../../../../../templates/components/PracticeLocationSelector';

const MembershipTypeDescriptions = [
  {
    value: 3,
    label: 'Option Package',
    description: 'Allows multiple options (services or products) that share a common pool of credits which are granted each period.',
  },
  {
    value: 2,
    label: 'Recurring',
    description: 'Each service or product receives its own separate set of credits every period.',
  },
  {
    value: 1,
    label: 'Bank',
    description: 'Members receive a fixed number of credits for each service or product at the start of the membership.',
  }
];

const MembershipPeriodUnitList = [
  { label: 'Month(s)', value: 'Month' },
  { label: 'Quarter(s)', value: 'Quarter' },
  { label: 'Year(s)', value: 'Year' }
];

const WizardStep1 = ({ formData, onChange, enableNext }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    onChange({ [name]: type === 'checkbox' ? checked : value });
  };

  const handleSelectChange = (name, value) => {
    onChange({ [name]: value });
  };

  useEffect(() => {
    // Validate required fields to enable Next button
    const isValid = (formData.name && formData.practiceLocationId && formData.membershipType && formData.unitPrice);
    enableNext(isValid);
  }, [formData]);


  return (
  <>
      <h4 className="mb-4">Membership Name, Type And Price</h4>





    <div className="row g-3">

      {/* Membership Name */}
      <div className="col-md-4" style={{margin:'unset'}}>
        <label>Name *</label>
        <input
          type="text"
          name="name"
          value={formData.name || ''}
          onChange={handleChange}
          className="form-control"
        />
      </div>

      {/* Location Selector */}
      <div className="col-md-4" style={{margin:'unset'}}>
        <label>Location *</label>
        <PracticeLocationSelector
          locationId={formData.practiceLocationId}
          onSelected={(value) => onChange({ practiceLocationId: value })}
        />
      </div>



    </div>


    <div className="row g-3">

      {/* Membership Type Radio Buttons */}
      <div className="col-md-12" >
        <label className="mb-2">Type *</label>
        <div className="d-flex flex-column">
          {MembershipTypeDescriptions.map(({ value, label, description }) => (
            <div key={value} className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="membershipType"
                id={`membershipType_${value}`}
                value={value}
                checked={formData.membershipType === value}
                onChange={(e) => handleChange({ target: { name: 'membershipType', value: parseInt(e.target.value) } })}
              />
              <label className="form-check-label" htmlFor={`membershipType_${value}`}>
                <strong>{label}</strong> – <span className="text-muted">{description}</span>
              </label>
            </div>
          ))}
        </div>
      </div>

    </div>



    <div className="row g-3">

        <div className="row g-3">

          <div className="col-12">
            <h5 className="mt-4 mb-0">How much will clients be charged?</h5>
          </div>

          <div className="col-md-4" style={{margin:'unset'}}>
            <label>Price *</label>
            <input
              type="number"
              name="unitPrice"
              value={formData.unitPrice || ''}
              onChange={handleChange}
              className="form-control"
            />
          </div>

        </div>


    </div>



















  </>

  );
};

export default WizardStep1;
